import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { ISRResponse } from '_core/types';
import { ResetPasswordAccountIssueTypes } from '../Types';

const machine = Machines.onResetPasswordAccountIssue.machine;

export const resetPasswordAccountIssue = (
  params: ResetPasswordAccountIssueTypes.ResetPasswordAccountIssueServiceRequestType,
): Promise<ISRResponse> => {
  return callServiceMachine(machine, params);
};

export default { resetPasswordAccountIssue };
